import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ApiMailHelperService {
  status = [
    { id: 'waiting', name: 'En attente', color: 'primary' },
    { id: 'requested', name: 'Envoi demandé', color: 'primary' },
    { id: 'sent', name: 'Envoyé', color: 'info' },
    { id: 'delivered', name: 'Délivré', color: 'info' },
    { id: 'opened', name: 'Ouvert', color: 'success' },
    { id: 'error', name: 'Erreur', color: 'warn' },
  ];

  getStatusName(project: any) {
    let status = this.status.find((item) => item.id == project?.status);
    return status?.name || 'Inconnu';
  }

  getStatusColor(project: any) {
    let status = this.status.find((item) => item.id == project?.status);
    return status?.color || 'accent';
  }
}
